import { render, staticRenderFns } from "./XeroInvoices.vue?vue&type=template&id=59feb220&"
import script from "./XeroInvoices.vue?vue&type=script&lang=js&"
export * from "./XeroInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports